import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#67768E",
      "stroke-width": "1.2"
    }, [
      _createElementVNode("path", {
        fill: "#fff",
        d: "M5.312 6.39a5.544 5.544 0 0 1 11.088 0c0 1.914-1.046 3.727-2.519 5.201-1.056 1.003-2.622 2.292-4.034 3.386a63 63 0 0 1-1.9 1.423c-.55.393-.928.639-1.083.716-.077.039-.224.064-.475-.003a3 3 0 0 1-.837-.407c-.611-.41-1.131-.977-1.327-1.37-.124-.248-.08-.636.2-1.355.066-.171.146-.36.231-.561.227-.536.492-1.16.64-1.77.208-.859.202-1.88.155-2.806q-.031-.581-.07-1.09c-.036-.514-.069-.97-.069-1.365Z"
      }),
      _createElementVNode("path", { d: "M4.584 15.605H1.768a.768.768 0 0 0 0 1.536h5.376" }),
      _createElementVNode("circle", {
        cx: "10.727",
        cy: "6.389",
        r: "2.472",
        fill: "#fff"
      })
    ], -1)
  ])))
}
export default { render: render }